<template>
  <div class="head">
    <div class="left-box" :class="{'hasBackBtn':!hideBack}">
      <slot></slot>
    </div>
    <div class="right-box">
      <slot name="btn-list"></slot>
      <el-button class="fixed-back-btn" @click="back()" v-if="!hideBack">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["type","hideBack"],
  data() {
    return {
      showInfo: false,
    };
  },
  watch: {},
  computed: {},

  created() {},
  mounted() {},
  methods: {
    back() {
      history.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  display: flex;
  padding: 25px 30px;
  justify-content: space-between;
  background: #fff;
  .left-box {
    width: 100%;
    &.hasBackBtn{
      width: calc(100% - 80px);
    }
    img {
      width: 26px;
      vertical-align: top;
    }
    .icon {
      width: 26px;
      height: 26px;
      margin: auto;
      border-radius: 50%;
      font-size: 30px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      &.green {
        background: #ebffea;
        color: #24C453;
      }
      &.blue{
        background: #cae1ff;
        color: rgb(64,158,255);
      }
      &.purple{
        background: rgb(209,214,255);
        color: #945AFF;
      }
    }
    .text-box {
      width: calc(100% - 40px);
      vertical-align: top;
      display: inline-block;
      margin-left: 5px;
      .text1 {
        font-size: 18px;
        color: #333;
        font-weight: bold;
        margin-bottom: 10px;
        margin-top: 3px;
      }
      .text2 {
        font-size: 14px;
        color: #666;
      }
      .text3 {
        color: #888;
        font-size: 12px;
        margin-top: 6px;
      }
    }
  }
  .right-box {
    display: flex;
    height: 100%;
    .org-btn {
      min-width: 70px;
      width: auto;
      padding: 0 15px;
    }
    .el-button {
      height: 29px;
    }
  }
  .fixed-back-btn {
    top: 0;
  }
}
  
</style>
